import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { Remittance } from '../../../../../models/remittances/remittance';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseComponent } from '../../../../../models/base/base-component';
import { Router } from '@angular/router';
import { RemittanceStatusIdEnum } from '../../../../../models/enum/remittance-status-id.enum';

@Component({
  selector: 'app-remittance-item-header',
  templateUrl: './remittance-item-header.component.html',
  styleUrls: ['./remittance-item-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemittanceItemHeaderComponent extends BaseComponent implements OnChanges {
  @Input() remittance!: Remittance;
  @Input() showActionButton = true;
  @Input() hideAccordion = false;
  @Input() accordionExpanded = false;
  @Input() isLoading = false;
  @Output() headerClicked = new EventEmitter<boolean>();

  private router = inject(Router);

  private _remittance = new BehaviorSubject<Remittance | null>(null);
  public remittance$ = this._remittance.pipe(filter((remittance): remittance is Remittance => !!remittance));

  private _accordionExpanded = new BehaviorSubject<boolean>(this.accordionExpanded);
  public accordionExpanded$ = this._accordionExpanded as Observable<boolean>;

  public buttonLabel$ = this.remittance$.pipe(
    map(r => {
      const edit = r?.statusId === RemittanceStatusIdEnum.Pending;
      return edit ? $localize`Edit` : $localize`View`;
    })
  );

  public viewRemittance() {
    this.remittance$.once(r => {
      const action = r?.isProcessing() ? 'process' : 'edit';
      this.router.navigate([`/remittances/${r?.id}/${action}`]).then();
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.remittance) {
      this._remittance.next(this.remittance);
    }
    if (changes.accordionExpanded) {
      this._accordionExpanded.next(this.accordionExpanded);
    }
  }

  setupViews(): void {}
  setupBindings(): void {}

  public toggleAccordion() {
    this.accordionExpanded$.once(expanded => {
      this._accordionExpanded.next(!expanded);
      this.headerClicked.next(!expanded);
    });
  }
}
